import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const profilePageStyle = {
  container,
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  white: {
    color: "white !important"
  },
  imgProfile:{
    width:"orginal",
    maxWidth:"160px",
    maxHeight:"160px"
  },
  downloadResume: {
    marginTop: "20px",
    fontSize: "12px",

  },
  other:{
    background: "#4caf50",
    position: "absolute",
    right: "15px",
    color: "white !important",
    "&:hover": {
    color: "white !important",
    }
  },
  fileUploader: {
    display: "none",
    backgroundColor: "red"
  },
  scoreBox: {
    textAlign: "center",
    position: "relative",
    display: "inline-block",
    top: "-150px",
  },
  downloadResume: {
    top: "40px",
    display: "inline-block",
    position: "absolute",
    textAlign: "center",
    left: "0px"
  },
  '@media (max-width: 600px)': {
    scoreBox: {
      width: "100%",
      marginTop: "20px",
      marginBottom: "20px",
      textAlign: "center",
      display: "inline-block",
      top: "0px !important",
    },
    downloadResume: {
      width: "100%",
      marginTop: "0px",
      marginBottom: "20px",
      textAlign: "center",
      display: "inline-block",
      top: "0px !important",
      position: "relative",

    },
  },
  profileImageEditButton: {
    right: "-54px",
    borderRadius: "100%",
    textAlign: "center",
    position: "relative",
    display: "inline-block",
    top: "-37px",
    color: "white",
    backgroundColor: "#4caf50",
    width: "35px",
    height: "35px",
    padding: "5px",
    verticalAlign: "middle"

  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#999",
    textAlign: "center !important"
  },
  name: {
    marginTop: "-80px"
  },

  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },

  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
  fastAccess: {
    direction: "ltr",
    textAlign: "left",
    marginTop: "30px",
    marginBottom: "20px"
  },
  fastAccessButton: {
    backgroundColor: "#f50057"
  },
  direction: {
    direction: "ltr"
  },
  card: {
    marginBottom: "15px",
  },
  left: {
    textAlign: "right",
    width: "100%"
  },
  justify: {
    textAlign: "justify"
  },
  description: {
    marginTop: "10px",
    position: "absolute",
    bottom: "0"
  },
  cardtitle: {
    minHeight: "110px",
    display: "block"
  }
}

export default profilePageStyle;
